<template>
    <div class="search-empty">
        <img class="empty-image" src="/img/empty.png" alt="暂未搜索到结果">
        <div class="empty-tip">{{tips||'没有找到相关课程，请先看看别的吧～'}}</div>
    </div>

</template>

<script>
    export default {
        name: "empty",
        props: {
            tips: String
        },
    }
</script>

<style scoped lang="scss">
    .search-empty {
        margin-top: 100px;
        width: 100%;
        text-align: center;
        .empty-tip {
            text-align: center;
            font-size: 14px;
        }
        .empty-image{
            width: 300px;
            height: 300px;
        }

    }
</style>